import React, { useId } from "react";
import { Tooltip } from "react-tooltip";
import { ReactComponent as InfoIcon } from "src/assets/icons/icon-info.svg";

import "./button.scss";

interface IButtonProps {
  className?: string;
  title?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  pending?: boolean;
  tooltipMessage?: string;
  icon?: React.ReactNode;
  type?: "button" | "submit" | "reset";
  secondary?: boolean;
}

const Button: React.FC<IButtonProps> = ({
  className,
  title,
  onClick,
  disabled = false,
  pending = false,
  tooltipMessage,
  icon,
  type = "button",
  secondary = false,
}) => {
  const isDisabled = disabled || pending;
  const buttonClass = `button ${secondary ? "button--secondary" : ""} ${className || ""} ${isDisabled ? "button-disabled" : ""} ${pending ? "button-pending" : ""}`;
  const tooltipId = useId();
  const hasTooltip = !!tooltipMessage;

  const buttonElement = (
    <button type={type} className={buttonClass} onClick={onClick} disabled={isDisabled}>
      {icon}
      {pending ? <span className="button-spinner" /> : title}
      {hasTooltip && !pending && <InfoIcon className="button-info-icon" aria-hidden="true" />}
    </button>
  );

  return (
    <>
      {hasTooltip ? (
        <span
          className="button-tooltip-wrapper"
          data-tooltip-id={tooltipId}
          data-tooltip-content={tooltipMessage}
        >
          {buttonElement}
        </span>
      ) : (
        buttonElement
      )}

      {hasTooltip && <Tooltip id={tooltipId} place="bottom" />}
    </>
  );
};

export default Button;
